import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Stack,
    Breadcrumbs,
    Tabs,
    Tab,
    Backdrop,
    CircularProgress
} from "@mui/material";
import { Link } from "react-router-dom";
import HomeIcon from '@mui/icons-material/Home';
import ScheduleIcon from '@mui/icons-material/Schedule';
import Dia from "./Dia";
import ProgramaPreliminar from "./ProgramaPreliminar";
import PropTypes from 'prop-types';
const live_events_service = require('../../helpers/live_events_service')

const primary = "#0d1e4a";
const gold = "#c9a43b";

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
            style={{ width: '100%' }}
        >
            {value === index && <Box sx={{ paddingLeft: { xs: '0%', md: '5%', lg: '10%' }, paddingRight: { xs: '0%', md: '5%', lg: '10%' } }} >{children}</Box>}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
export default function Programa() {
    const [contador] = useState(0);
    const [programa, setPrograma] = useState([]);
    const [value, setValue] = React.useState(0);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        live_events_service
            .getData(
                "/programa/view/" +
                process.env.REACT_APP_EVT
            )
            .then((response_programa) => {
                const speakers = response_programa?.data?.response_database?.programa?.speakers;
                setPrograma(Array.isArray(speakers) ? speakers : []);
                setLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setPrograma([]);
                setLoading(false);
            });

    }, [contador]);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    // Si el API devuelve null, vacío o nada, se muestra el programa preliminar quemado
    const hayPrograma = Array.isArray(programa) && programa.length > 0;
    const dia_1 = {
        title: null, segments: [
            { title: null, begin: 0, end: 13 },
        ]
    }
    const dia2 = {

        title: null, segments: [
            { title: null, begin: 14, end: 26 },
        ]

    }
    return (
        <Box sx={{ width: '100%', minHeight: '100vh', background: '#f7f8fb' }}>
            <Stack spacing={hayPrograma ? 5 : 3} alignItems='center' pt={3}>
                <Backdrop
                    sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={loading}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Breadcrumbs aria-label="breadcrumb">
                    <Link
                        underline="hover"
                        sx={{ display: 'flex', alignItems: 'center' }}
                        color="inherit"
                        to="/"
                    >
                        <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                        Inicio
                    </Link>
                    <Typography
                        sx={{ color: 'text.primary', display: 'flex', alignItems: 'center' }}
                    >
                        <ScheduleIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                        Programa
                    </Typography>
                </Breadcrumbs>
                {!loading && !hayPrograma && <ProgramaPreliminar />}
                {hayPrograma && (
                    <>
                        <Box sx={{ width: '100%' }}>
                            <Tabs
                                value={value}
                                onChange={handleChange}
                                sx={{
                                    '& .MuiTabs-indicator': {
                                        backgroundColor: gold,
                                    },
                                    '& .Mui-selected': {
                                        color: `${primary} !important`,
                                    },
                                }}
                                centered
                            >
                                <Tab  {...a11yProps(0)} label="Día 1" />
                                <Tab  {...a11yProps(1)} label="Día 2" />
                            </Tabs>
                        </Box>
                        <CustomTabPanel value={value} index={0}>
                            <Dia config={dia_1} programa={programa} />
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={1}>
                            <Dia config={dia2} programa={programa} />
                        </CustomTabPanel>
                    </>
                )}
            </Stack>
        </Box>
    );
}
